import axios from "axios";
import { store } from "../redux/store";
import { logoutUser } from "../redux/user/userSlice";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const state = store.getState();
  const csrfToken = (state as any).user?.user?.csrfToken;
  if (csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

const forceLogout = (message?: string) => {
  store.dispatch(logoutUser());
  localStorage.removeItem("persist:user");
  if (message) {
    sessionStorage.setItem("sessionExpiredMessage", message);
  }
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const message = error?.response?.data?.message || "";
      if (
        message === "Invalid or expired token" ||
        message === "Unauthorized user" ||
        message === "Unauthorized"
      ) {
        forceLogout(
          "Your session has expired. Please sign in again to continue.",
        );
      }
    }
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.message === "CSRF validation failed"
    ) {
      forceLogout("CSRF validation failed. Please sign in again.");
    }
    return Promise.reject(error);
  },
);

export default apiClient;
